export default __webpack_public_path__ + "static/Revontulikamera_loop_PAKATTU-a20d3f9208bc2b7e1ac73950db3233ef.mp4";